<template>
  <div class="row" v-on:mousemove="checkInactivityMoveMouse">
    <div
      class="col d-flex justify-content-between align-items-center"
      v-if="loading == false"
    >
      <div class="col-md-auto px-0">
      <botao-remanejar class="mb-3" servico="acolhimento-crianca" :registro="acolhimento" @remanejado="$router.go(-1)" />
        <h1 class="h3 mb-3 text-gray-800">
          Acolhimento: #{{ $route.params.id }}
        </h1>
      </div>
      <div class="col-md-auto">
        <nav aria-label="breadcrumb" v-if="acolhimento">
          <ol class="breadcrumb" style="display: flex">
            <li class="breadcrumb-item active" aria-current="page">
              <router-link
                :to="`/dashboard/acolhimentos/${acolhimento.unidade_id}`"
              >
                Acolhimentos
              </router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              Acolhimento #{{ $route.params.id }}
            </li>
          </ol>
        </nav>
      </div>
    </div>
    <load v-if="loading" message="Carregando acolhimento" />
    <div v-else class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          <Header :item="acolhimento" />
        </div>
      </div>
      <!--Tabela-->
      <div class="row">
        <SidebarServico :active="page" @page="showPage" />
        <ModalVerificarPrivado
          :familia-id="acolhimento.familia_id"
          v-if="acolhimento.privado == 1 && status_privado == false"
          @liberar="status_privado = true"
        />
        <div
          v-else
          class="col-md-9"
          v-on:mousemove="status_privado = !checkInactivity"
        >
          <div v-if="page == 'home'">
            <div v-if="historicoStatus == false" class="card mb-0 shadow">
              <div class="card-body">
                <div class="tab-content">
                  <div class="animate__animated animate__fadeIn">
                    <div class="col-12 px-0">
                      <h4 class="font-weight-bold">Editar Acolhimento</h4>
                    </div>
                    <HeaderAcolhimento class="px-0" :item="acolhimento" />
                    <b-tabs content-class="mt-3">
                      <b-tab title="Detalhes" active>
                        <Detalhe
                          :item="acolhimento"
                          @submit="submit"
                          @reload="getAcolhimento"
                        />
                      </b-tab>
                      <b-tab title="Documentação/Identificação Processual">
                        <Documentacao
                          @reload="getAcolhimento"
                          :item="acolhimento"
                          @submit="submit"
                        />
                      </b-tab>
                      <b-tab title="Tipo de vínculo">
                        <Dinamica
                          @reload="getAcolhimento"
                          :item="acolhimento"
                          @submit="submit"
                        />
                      </b-tab>
                    </b-tabs>
                  </div>
                </div>
              </div>
            </div>
            <div class="card mb-0 shadow card-body" v-else>
              <div class="tab-content">
                <div class="animate__animated animate__fadeIn">
                  <div class="row">
                    <div class="col-12">
                      <h4 class="font-weight-bold">Editar Acolhimento</h4>
                    </div>
                    <!-- <HistoricoStatus
											@voltar="historicoStatus = false"
											:id="acolhimento.id"
											:familia="acolhimento.familia_id"
											:status="status_acolhimento"
										/> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <PrimeiraObservacao
            :item="acolhimento"
            v-if="page == 'primeira'"
            @submit="submit"
          />
          <Caracteristica
            :item="acolhimento"
            v-if="page == 'caracteristica'"
            @submit="submit"
          />
          <Observacao
            :item="acolhimento"
            v-if="page == 'observacao'"
            @reload="getAcolhimento"
          />
          <ObjetivoCrianca
            :item="acolhimento"
            v-if="page == 'objetivo_crianca'"
            @submit="submit"
          />
          <ObjetivoResponsavel
            :item="acolhimento"
            v-if="page == 'objetivo_responsavel'"
            @submit="submit"
          />
          <AtividadesCrianca
            v-if="page === 'atividade' && acolhimento && acolhimento.id"
            :key="acolhimento.id"
            :item="acolhimento"
          />
          <Encaminhamentos
            :item="acolhimento"
            v-if="page == 'encaminhamentos'"
            @submit="submit"
            @reload="submit"
          />
          
          <Termo :item="acolhimento" v-if="page == 'termo'" />
          <Pia :item="acolhimento" v-if="page == 'pia'" />
          <Auditoria :id="acolhimento.id"  v-if="page == 'historicopia'"/>
        </div>
      </div>
    </div>
    <!-- <status-historico
			model="Acolhimento"
			modulo="Acolhimento"
			:id="acolhimento.id"
			:status-anterior="statusAnterior"
			:status-atual="statusAtual"
			:status="status_acolhimento"
			@submit="submit"
		/>-->
  </div>
</template>
<script>
import SidebarServico from "../includes/SidebarServico";
import Header from "../includes/Header";
import HeaderAcolhimento from "../includes/HeaderAcolhimento";
import HistoricoStatus from "../HistoricoStatus";
import PrimeiraObservacao from "../includes/abas/PrimeiraObservacao";
import Caracteristica from "../includes/abas/Caracteristica";
import Auditoria from "../includes/abas/Auditoria";
import Observacao from "../includes/abas/Observacao";
import ObjetivoCrianca from "../includes/abas/ObjetivoCrianca";
import ObjetivoResponsavel from "../includes/abas/ObjetivoResponsavel";
import AtividadesCrianca from "../includes/abas/AtividadesCrianca.vue";
import Pia from "../includes/abas/PIA";
import Termo from "../includes/abas/Termo";
import Documentacao from "../includes/abas/Documentacao";
import Dinamica from "../includes/abas/Dinamica";
import Detalhe from "../includes/abas/Detalhe";
import ModalVerificarPrivado from "../includes/ModalVerificarPrivado";
import Encaminhamentos from "../includes/abas/Encaminhamento";

export default {
  components: {
    SidebarServico,
    Auditoria,
    Header,
    HeaderAcolhimento,
    HistoricoStatus,
    PrimeiraObservacao,
    Caracteristica,
    Observacao,
    ObjetivoCrianca,
    ObjetivoResponsavel,
    AtividadesCrianca,
    Pia,
    Termo,
    Dinamica,
    Detalhe,
    Documentacao,
    ModalVerificarPrivado,
    Encaminhamentos,
  },
  name: "Edit",
  data() {
    return {
      page: "home",
      acolhimento: {},
      familia: {},
      files: {},
      status_privado: false,
      loading: true,
      progressCompleted: 0,
      historicoStatus: false,
      model: "Acolhimento",
    };
  },
  mounted() {
    this.getAcolhimento();
    this.$bvModal.show("verificar-acolhimento-privado");
  },
  computed: {
    checkInactivity() {
      if (this.$root.isIdle == true) {
        this.status_privado = false;
        this.$bvModal.show("verificar-acolhimento-privado");
      }
      return this.$root.isIdle;
    },
  },
  methods: {
    checkInactivityMoveMouse() {
      if (this.acolhimento.privado == 1) {
        if (this.$root.isIdle == true) {
          this.status_privado = false;
          this.$bvModal.show("verificar-acolhimento-privado");
        }
        return this.$root.isIdle;
      } else {
        return false;
      }
    },
    showPage(page) {
      this.page = page;
    },

    getAcolhimento() {
      let id = this.$route.params.id;
      axios
        .get(`api/dashboard/acolhimento/${id}`)
        .then((response) => {
          this.acolhimento = response.data.data;
        })
        .finally(() => {
          this.loading = false;
        })
        .catch((error) => {
          this.$router.push("/dashboard/acolhimento/unidades");
        });
    },

    submit() {
      if (this.acolhimento.data_acolhimento) {
        this.acolhimento.data_acolhimento = moment(
          this.acolhimento.data_acolhimento,
          "YYYY-MM-DD"
        ).format("YYYY-MM-DD");
      }
      if (this.acolhimento.medida_data_entrada) {
        this.acolhimento.medida_data_entrada = moment(
          this.acolhimento.medida_data_entrada,
          "YYYY-MM-DD"
        ).format("YYYY-MM-DD");
      }
      if (this.acolhimento.medida_data_saida) {
        this.acolhimento.medida_data_saida = moment(
          this.acolhimento.medida_data_saida,
          "YYYY-MM-DD"
        ).format("YYYY-MM-DD");
      }

      if (this.acolhimento.hora_acolhimento) {
        this.acolhimento.hora_acolhimento = moment(
          this.acolhimento.hora_acolhimento,
          "YYYY-MM-DD H:mm"
        ).format("YYYY-MM-DD H:mm");
      }

      if (this.acolhimento.tecnicos) {
        this.acolhimento.tecnicos = this.acolhimento.tecnicos
          .map((item) => {
            if (item && typeof item === "object") {
              return item.id;
            }

            return item;
          })
          .filter((item) => {
            return item !== null &&
              item !== undefined &&
              item !== "" &&
              !isNaN(Number(item));
          })
          .map((item) => Number(item));
      }

      let ladda = Ladda.create(document.querySelector(".btn-submit"));
      ladda.start();

      axios
        .post(`api/dashboard/acolhimento/update`, this.acolhimento, {
          header: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (event) => {
            let progress = Math.round((event.loaded * 100) / event.total);
            this.progressCompleted = progress;
          },
        })
        .then((response) => {
          this.acolhimento = response.data.data;
          ladda.stop();
          this.$snack.success({
            button: false,
            text: "Dados salvos com sucesso.",
          });
          //window.location.reload();
          this.$emit("voltar");
          this.$emit("reload");
        })
        .finally(() => {
          this.progressCompleted = 0;
          this.files = [];
        });
    },
  },
};
</script>
<style>
.router-link-exact-active {
  cursor: pointer;
}
</style>
